import { initMercadoPago, Payment } from "@mercadopago/sdk-react";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { projectFirestore } from "../../firebase/config";
import { getDoc, doc } from "firebase/firestore";

const Pagos = () => {
  const [preferenceId, setPreferenceId] = useState(null);
  const [dataOrden, setDataOrden] = useState(null);
  const [errorMessage, setErrorMessage] = useState(null);
  const [atok, setAtok] = useState("");
  const [amount, setAmount] = useState(0);
  const { idOrden } = useParams();
  const customization = {
    visual: {
      style: {
        theme: "dark",
      },
    },
    paymentMethods: {
      creditCard: "all",
      debitCard: "all",
      mercadoPago: "all",
    },
  };

  const onSubmit = async (obj) => {
    const { formData } = obj;
    return new Promise((resolve, reject) => {
      fetch(
        //"http://192.168.140.87:3001/process_payment",
        "https://us-central1-rap-dis.cloudfunctions.net/default/process_payment",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            data: formData,
            atok: atok,
            idOrden: idOrden,
          }),
        },
      )
        .then((response) => response.json())
        .then(async (response) => {
          if (response.result.status === "approved") {
            window.location.href = "rapdisapp://aproved/0";
            setErrorMessage("Pago aprobado.");
          } else {
            setErrorMessage("Pago rechazado.");
          }
          resolve();
        })
        .catch((error) => {
          console.log(error);
          reject();
        });
    });
  };

  const onError = async (error) => {
    console.log(error);
  };

  const onReady = async () => {
    const targetDiv = document.querySelector("#paymentBr");
    const observer = new MutationObserver((mutations) => {
      window.scrollTo({
        top: targetDiv.scrollHeight,
        behavior: "smooth",
      });
    });
    const config = {
      attributes: true,
      childList: true,
      characterData: true,
      subtree: true,
    };

    observer.observe(targetDiv, config);
  };

  useEffect(() => {
    const createPreference = async () => {
      try {
        let items = dataOrden.detalle.map((item) => {
          return {
            title: item.name,
            quantity: parseInt(item.cantidad),
            currency_id: "MXN",
            unit_price: parseFloat(item.costo),
          };
        });
        let totalextras = 0;
        dataOrden.detalle.forEach((element) => {
          totalextras += parseFloat(element.totalAnadidos);
        });
        items.push({
          title: "Extras",
          quantity: 1,
          currency_id: "MXN",
          unit_price: totalextras,
        });
        if (
          dataOrden.puntosusados &&
          parseFloat(dataOrden.puntosusados) > 0 &&
          dataOrden.equivalenciapuntos &&
          parseFloat(dataOrden.equivalenciapuntos) > 0
        )
          items.push({
            title: "Descuento",
            quantity: 1,
            currency_id: "MXN",
            unit_price: -parseFloat(
              dataOrden.puntosusados * dataOrden.equivalenciapuntos,
            ),
          });
        const response = await axios.post(
          //"http://192.168.140.87:3001/create_preference",
          "https://us-central1-rap-dis.cloudfunctions.net/default/create_preference",
          {
            items: items,
            atok: atok,
            idO: idOrden,
            idNegocio: dataOrden.puesto,
          },
        );
        const { id } = response.data;
        return id;
      } catch (err) {
        console.log(err);
        setErrorMessage(
          "Error al crear pago, favor de ponerse en contacto con el negocio.",
        );
      }
    };
    const handleBuy = async () => {
      const id = await createPreference();
      if (id) {
        setPreferenceId(id);
      }
      let tot = parseFloat(
        parseFloat(dataOrden.total) -
          (dataOrden.puntosusados ? parseFloat(dataOrden.puntosusados) : 0) *
            (dataOrden.equivalenciapuntos
              ? parseFloat(dataOrden.equivalenciapuntos)
              : 0),
      );
      setAmount(tot);
    };
    if (!dataOrden) {
      getDoc(doc(projectFirestore, "turnero", idOrden))
        .then((dataOrd) => {
          if (dataOrd.exists()) {
            let datos = dataOrd.data();
            getDoc(doc(projectFirestore, "registro", datos.puesto))
              .then((datosR) => {
                if (datosR.exists()) {
                  let datosPuesto = datosR.data();
                  setAtok(datosPuesto.AT);
                  initMercadoPago(datosPuesto.MPK, { locale: "es-MX" });
                }
              })
              .catch((err) => {
                console.log(err);
                setErrorMessage(
                  "Hubo un error al cargar el puesto, favor de contactar al administrador del negocio.",
                );
              });
            if (datos.status === "PENDIENTE") {
              setDataOrden(datos);
            } else {
              setErrorMessage(
                "La orden ya fue atendida o cancelada, no se puede realizar el pago.",
              );
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else if (atok !== "" && !preferenceId) {
      handleBuy();
    }
  }, [atok, dataOrden, idOrden, preferenceId]);

  return (
    <div className="container margin-login">
      <div className="row justify-content-center">
        {!dataOrden || errorMessage ? (
          <h2>{errorMessage}</h2>
        ) : (
          <div
            style={{
              alignItems: "stretch",
              display: "flex",
              flexFlow: "row",
              flexWrap: "wrap",
              justifyContent: "center",
              alignContent: "center",
            }}
          >
            <div
              className="col-lg-6 col-md-6 col-sm-8"
              style={{
                alignContent: "center",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                padding: "20px",
              }}
            >
              <h2>Detalles de tu orden</h2>
              <p>
                Total: $
                {(
                  parseFloat(dataOrden.total) -
                  (dataOrden.puntosusados
                    ? parseFloat(dataOrden.puntosusados)
                    : 0) *
                    (dataOrden.equivalenciapuntos
                      ? parseFloat(dataOrden.equivalenciapuntos)
                      : 0)
                ).toFixed(2)}
              </p>
              <div className="">
                {dataOrden.detalle.map((item, index) => (
                  <div key={index}>
                    <p style={{ display: "list-item", textAlign: "justify" }}>
                      {item.name}({item.cantidad}): $
                      {parseFloat(item.total).toFixed(2)}
                    </p>
                    <div style={{ paddingTop: "0px", paddingBottom: "10px" }}>
                      {item.anadidos ? (
                        Object.keys(item.anadidos).map((obj, i) => {
                          return (
                            <div key={i}>
                              -{item.anadidos[obj].name}(
                              {parseFloat(
                                item.anadidos[obj].precio *
                                  item.anadidos[obj].cantidad,
                              ) > 0
                                ? "+$" +
                                  (
                                    item.anadidos[obj].precio *
                                    item.anadidos[obj].cantidad
                                  ).toFixed(2)
                                : "Gratis"}
                              )
                            </div>
                          );
                        })
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                ))}
                {parseFloat(dataOrden.puntosusados) > 0 ? (
                  <div>
                    <p style={{ display: "list-item", textAlign: "justify" }}>
                      Puntos usados(
                      {dataOrden.puntosusados ? dataOrden.puntosusados : 0}): -$
                      {(
                        parseFloat(dataOrden.puntosusados) *
                        parseFloat(dataOrden.equivalenciapuntos)
                      ).toFixed(2)}
                    </p>
                  </div>
                ) : (
                  <></>
                )}
              </div>
              {/* <button onClick={handleBuy}>Pagar con tarjeta</button> */}
            </div>
            {(preferenceId && (
              <div className="col-lg-6 col-md-6 col-sm-8">
                <Payment
                  id="paymentBr"
                  initialization={{
                    amount: amount,
                    preferenceId: preferenceId,
                  }}
                  customization={customization}
                  onSubmit={onSubmit}
                  onReady={onReady}
                  onError={onError}
                />
              </div>
            )) ||
              (errorMessage && (
                <div className="col-lg-6 col-md-6 col-sm-8">
                  <h2 style={{ textAlign: "center" }}>{" " + errorMessage}</h2>
                </div>
              ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Pagos;
